/* eslint-disable no-restricted-properties */
/* eslint-disable no-bitwise */

// Code ported from https://github.com/mad-gooze/fast-blurhash

var digit = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz#$%*+,-.:;=?@[]^_{|}~';
var decode83 = function decode83(str, start_, end) {
  var value = 0;
  var start = start_;
  while (start < end) {
    value *= 83;
    value += digit.indexOf(str[start]);
    start += 1;
  }
  return value;
};
var PI = Math.PI,
  pow = Math.pow;
var PI2 = PI * 2;
var d = 3294.6;
var e = 269.025;
var sRGBToLinear = function sRGBToLinear(value) {
  return value > 10.31475 ? pow(value / e + 0.052132, 2.4) : value / d;
};
var linearTosRGB = function linearTosRGB(v) {
  return ~~(v > 0.00001227 ? e * pow(v, 0.416666) - 13.025 : v * d + 1);
};
var signSqr = function signSqr(x) {
  return (x < 0 ? -1 : 1) * x * x;
};
var fastCos = function fastCos(x) {
  var newX = x + PI / 2;
  while (newX > PI) {
    newX -= PI2;
  }
  var cos = 1.27323954 * newX - 0.405284735 * signSqr(newX);
  return 0.225 * (signSqr(cos) - cos) + cos;
};
function getBlurHashAverageColor(blurHash) {
  var val = decode83(blurHash, 2, 6);
  return [val >> 16, val >> 8 & 255, val & 255];
}
function decodeBlurHash(blurHash, width, height) {
  var punch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var sizeFlag = decode83(blurHash, 0, 1);
  var numX = sizeFlag % 9 + 1;
  var numY = ~~(sizeFlag / 9) + 1;
  var size = numX * numY;
  var i = 0;
  var j = 0;
  var x = 0;
  var y = 0;
  var r = 0;
  var g = 0;
  var b = 0;
  var basis = 0;
  var basisY = 0;
  var colorIndex = 0;
  var pixelIndex = 0;
  var yh = 0;
  var xw = 0;
  var value = 0;
  var maximumValue = (decode83(blurHash, 1, 2) + 1) / 13446 * (punch | 1);
  var colors = new Float64Array(size * 3);
  var averageColor = getBlurHashAverageColor(blurHash);
  for (i = 0; i < 3; i += 1) {
    colors[i] = sRGBToLinear(averageColor[i]);
  }
  for (i = 1; i < size; i += 1) {
    value = decode83(blurHash, 4 + i * 2, 6 + i * 2);
    colors[i * 3] = signSqr(~~(value / (19 * 19)) - 9) * maximumValue;
    colors[i * 3 + 1] = signSqr(~~(value / 19) % 19 - 9) * maximumValue;
    colors[i * 3 + 2] = signSqr(value % 19 - 9) * maximumValue;
  }
  var bytesPerRow = width * 4;
  var pixels = new Uint8ClampedArray(bytesPerRow * height);
  for (y = 0; y < height; y += 1) {
    yh = PI * y / height;
    for (x = 0; x < width; x += 1) {
      r = 0;
      g = 0;
      b = 0;
      xw = PI * x / width;
      for (j = 0; j < numY; j += 1) {
        basisY = fastCos(yh * j);
        for (i = 0; i < numX; i += 1) {
          basis = fastCos(xw * i) * basisY;
          colorIndex = (i + j * numX) * 3;
          r += colors[colorIndex] * basis;
          g += colors[colorIndex + 1] * basis;
          b += colors[colorIndex + 2] * basis;
        }
      }
      pixelIndex = 4 * x + y * bytesPerRow;
      pixels[pixelIndex] = linearTosRGB(r);
      pixels[pixelIndex + 1] = linearTosRGB(g);
      pixels[pixelIndex + 2] = linearTosRGB(b);
      pixels[pixelIndex + 3] = 255; // alpha
    }
  }
  return pixels;
}

export { decodeBlurHash };
//# sourceMappingURL=blurhash.js.map
